import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IPerfilDTO, IPerfilGetProps } from "../../../types/perfil";
import { useContextSite } from "../../../context/Context";
import { Perfil } from "../../../services/Perfil";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { IPagination } from "../../../types/pagination";
import { useSessionStorage } from "../../../hooks/useSessionStorage";

export const useProfiles = () => {
  const navigate = useNavigate();
  const [perfis, setPerfis] = useState<IPerfilDTO[]>([] as IPerfilDTO[]);
  const { setIsLoad } = useContextSite();
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const [usuario] = useSessionStorage("@usuarioMapa");
  const isAdmin = usuario?.roles?.includes("ROLE_ADMIN");
  const canAccessProfiles =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_PERFIL_VER");
  const canEditProfiles =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_PERFIL_EDITAR");

  function getPerfis(props?: IPerfilGetProps) {
    setIsLoad(true);
    Perfil.get({ size: 5, incluirInativos: true, ...props })
      .then(({ data }) => {
        setPerfis(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.numberOfElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    getPerfis({ page: numberPage });
  }, [numberPage]);

  return {
    navigate,
    perfis,
    isMobile,
    pagination,
    setNumberPage,
    canAccessProfiles,
    canEditProfiles,
  };
};
